import React, { useState } from "react";
import { Mail, Lock } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { onLoginMentor } from "../utils/api";
import toast from "react-hot-toast";
import { useAuth } from "../utils/authContext";
import Logo from "../assest/tactosnew.png";

const MentorLogin = () => {
  const [loader, setLoader] = useState(false)
  const { loginMentor } = useAuth();

  const navigate = useNavigate()
  const [data, setData] = useState({
    email: "",
    password: "",
  })

  const onLoginClick = async () => {
    setLoader(true)
    if (!data.email && !data.password) {
      setLoader(false)
      toast.error("Please enter email and password!")
      return
    }
    try {
      const res = await onLoginMentor(data)
      console.log(res)
      toast.success(res.message)
      localStorage.clear()
      localStorage.setItem("mentorToken", res.token)
      localStorage.setItem("mentorName", res.mentor.name)
      localStorage.setItem("mentorEmail", res.mentor.email)
      localStorage.setItem("mentorImage", res.mentor.image)
      navigate('/mentordashboard')
    } catch (error) {
      console.log(error)
      toast.error(error?.response?.data?.message)
    } finally {
      setLoader(false)
      setData({
        ...data,
        password: "",
        email: "",
      })
    }
  }
  return (
    <section className="min-h-screen flex items-center justify-center px-6 bg-gray-50">
      <div className="w-full max-w-xl bg-white rounded-2xl shadow-2xl p-8 md:p-10">

        {/* LOGO */}
        <div className="flex justify-center mb-6">
          <img
            src={Logo}
            alt="Tactos Logo"
            className="h-12 object-contain"
          />
        </div>

        {/* HEADER */}
        <div className="text-center mb-8">
          <h2 className="text-3xl font-extrabold text-gray-900">
            Mentor Login
          </h2>
          <p className="text-gray-600 text-sm mt-2">
            Sign in to access your Tactos dashboard
          </p>
        </div>

        {/* FORM */}
        <form className="space-y-6">

          {/* EMAIL */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email address
            </label>
            <div className="relative">
              <Mail
                className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                size={18}
              />
              <input
                required
                value={data.email}
                onChange={(e) =>
                  setData({ ...data, email: e.target.value })
                }
                type="email"
                placeholder="mentor@tactos.com"
                className="
              w-full px-4 py-3 pl-10
              border border-gray-200 rounded-lg
              bg-gray-50
              transition-all duration-200
              focus:bg-white
              focus:border-gray-400
              focus:ring-2 focus:ring-gray-100
              outline-none
            "
              />
            </div>
          </div>

          {/* PASSWORD */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <div className="relative">
              <Lock
                className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                size={18}
              />
              <input
                required
                value={data.password}
                onChange={(e) =>
                  setData({ ...data, password: e.target.value })
                }
                type="password"
                placeholder="••••••••"
                className="
              w-full px-4 py-3 pl-10
              border border-gray-200 rounded-lg
              bg-gray-50
              transition-all duration-200
              focus:bg-white
              focus:border-gray-400
              focus:ring-2 focus:ring-gray-100
              outline-none
            "
              />
            </div>
          </div>

          {/* LOGIN BUTTON */}
          <button
            type="button"
            onClick={onLoginClick}
            disabled={loader}
            className="
    w-full py-3
    bg-[#fd3e3d]
    text-white font-semibold rounded-lg
    hover:bg-[#e63939]
    transition-all duration-300
    flex items-center justify-center
    disabled:opacity-70
    disabled:cursor-not-allowed
    transform hover:-translate-y-0.5
    relative overflow-hidden group
  "
          >
            {/* SHINE EFFECT */}
            <div
              className="
      absolute inset-0
      bg-gradient-to-r from-white/0 via-white/30 to-white/0
      -skew-x-12
      -translate-x-full
      group-hover:translate-x-full
      transition-transform duration-1000
    "
            />

            {/* CONTENT */}
            <div className="relative z-10">
              {loader ? (
                <span className="flex items-center gap-2">
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Logging in...
                </span>
              ) : (
                "Login"
              )}
            </div>
          </button>


        </form>

        {/* DIVIDER */}
        <div className="my-6 border-t border-gray-200" />

        {/* FOOTER */}
        <div className="text-center text-sm text-gray-600">
          Not a mentor yet?
          <Link to="/mentorregister">
            <span className="text-[#fd3e3d] ml-1 font-medium cursor-pointer hover:underline">
              Sign up
            </span>
          </Link>
        </div>

      </div>
    </section>

  );
};

export default MentorLogin;
